<template>
    <div class="hts-form-button-group">
        <span>
            {{ label }}<span
                v-if="required"
                class="text-error-500 ml-1">
                *
            </span>
        </span>
        <div class="btn-group">
            <button
                v-for="(item, index) in items"
                :key="index"
                class="btn"
                :type="type"
                :class="{ 'bg-info-400': item[valueKey] === modelValue, 'bg-disabled bg-gray-300 border-none': item[valueKey] !== modelValue }"
                @click="handleClick(item, index, $event)">
                {{ item[labelKey] }}
            </button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { getCurrentInstance } from 'vue'

const uid = getCurrentInstance()?.uid

const props = defineProps({
  modelValue: [String, Number],
  items: {
    type: Array,
    default: () => []
  },
  label: String,
  prop: String,
  rules: {
    type: Object,
    default: () => ({})
  },
  valueKey: {
    type: String,
    default: 'id'
  },
  labelKey: {
    type: String,
    default: 'label'
  },
  size: String,
  color: String,
  required: Boolean,
  disabled: Boolean,
  readonly: Boolean,
  type: {
    type: String,
    default: 'submit'
  }
})
const { modelValue, items, valueKey, labelKey } = toRefs(props)
const errorMessage = ref('')

const emits = defineEmits(['update:modelValue', 'change', 'click'])
const check = computed({
  get () {
    return modelValue?.value
  },
  set (val) {
    emits('update:modelValue', val)
  }
})
const handleClick = (item: any, index: number, e: any) => {
  emits('update:modelValue', item[valueKey.value] ?? '')
  emits('change', item)
  emits('click', item)
}
</script>
